// extracted by mini-css-extract-plugin
export default {"blackBtn":"BlackButton_blackBtn__qKG4u","button":"BlackButton_button__XhwA+"};